
define('known/collections/leagueInstanceCollection',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueInstanceModel'
], function($, _, Backbone, LeagueInstanceModel){
	var LeagueInstanceCollection = Backbone.Collection.extend({
		//model : draftApp.model.LeagueInstance,
		model : LeagueInstanceModel,
		userName : null, //Populate this on construction
	
		url: function() {
			return '/draftapp/users/' + this.userName + '/leagues';
		},
		
		initialize: function(models, options) {
			this.userName = options.userName;
			this.on('userChange', this.updateLeagues);
	    },
	    
	    updateLeagues: function(){
	    	this.fetch();
	    },
	
		// Return all leagues under the specific product id
		leaguesForProduct : function(prodId) {
			var foundLgs =  this.filter(function(league) {;
				return league.get('prodId') == prodId;
			});
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
		
		// Return all leagues under the specific product id
		leaguesForYearSport : function(year, sportLgName) {
			this.year = year;
			this.sportLgName = sportLgName.toUpperCase();
			
			var foundLgs = this.filter(function(league) {;
				return league.get('prodLeagueName').toUpperCase() == this.sportLgName && league.get('year') == this.year;
			}, this);
			
			delete this.year;
			delete this.sportLgName;
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
		
		// Return all leagues whose status is STARTED
		getStartedLeagues : function() {
			var foundLgs = this.filter(function(league) {
				return league.get('draftStatus') == 'STARTED';
			});
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
		
		// Return all leagues whose status is PREDRAFT
		getPredraftLeagues : function() {
			var foundLgs = this.filter(function(league) {
				return league.get('draftStatus') == 'PREDRAFT';
			});
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
		
		// Return all leagues whose status is PREDRAFT
		getStartedOrPredraftLeagues : function() {
			var foundLgs = this.filter(function(league) {
				return league.get('draftStatus') == 'PREDRAFT' || league.get('draftStatus') == 'STARTED';
			});
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
		
		// Return all leagues whose status is SETUP
		getSetupLeagues : function() {
			var foundLgs = this.filter(function(league) {
				return league.get('draftStatus') == 'SETUP';
			});
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
		
		// Return all leagues whose status is COMPLETED
		getCompletedLeagues : function() {
			var foundLgs = this.filter(function(league) {
				return league.get('draftStatus') == 'COMPLETED';
			});
			
			if(foundLgs){
				var tempLeagues = _.sortBy(foundLgs, function(league){ return league.get("displayName"); }, this)
				foundLgs = tempLeagues
			}
			
			return foundLgs;
		},
	
		//Sort by a predetermined ranking of draft statuses: STARTED, PREDRAFT, SETUP, COMPLETED
		comparator : function(prod, compProd) {
			if(prod.get('draftStatus') == 'STARTED'){
				return -1;
			} else if (prod.get('draftStatus') == 'PREDRAFT' && compProd.get('draftStatus') != 'STARTED'){
				return -1;
			} else if (prod.get('draftStatus') == 'SETUP' 
					&& compProd.get('draftStatus') != 'STARTED' 
					&& compProd.get('draftStatus') != 'PREDRAFT') {
				return -1;
			} else {
				return 1;
			}
		}
	});
	
	return LeagueInstanceCollection;  
});